<template>
  <div class="centerWidth">
    <div class="btn-wrap">
      <el-button type="primary" class="download" @click="downloadCertificate">下载证书</el-button>
      <el-button type="" class="back-wrap" @click="toHome">返回</el-button>
    </div>
    <div class="down-wrap" ref="certificate" v-if="dataInfo">
      <div class="detail-wrap" >
<!--        <div class="title-wrap">-->
<!--          <img class="img1" src="../assets/images/logo11.png" alt="">-->
<!--          <div class="right">-->
<!--            <img class="img2" src="../assets/images/dagang_title4.png" alt="">-->
<!--            <div class="tit" v-if="dataInfo.is_muban == 1">中国中小企业协会专业技能建设工作委员会指定考培服务平台：www.rsx.org.cn</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="title">-->
<!--          <img src="../assets/images/dagang_title3.png" alt="">-->
<!--        </div>-->
<!--        <div class="line"></div>-->
<!--        <div class="con-wrap">-->
<!--          持证人参加专业机构组织的技术培训课程。经我平台统一测评考试合格，达到相关专业等级要求，特此证明。-->
<!--        </div>-->
        <table class="info-wrap" border="none">
          <tr>
<!--            <th>个人基本信息</th>-->
<!--            <th>考评专业信息</th>-->
          </tr>
          <tr>
            <td>
              <span>学员姓名：</span>
              <span>{{ dataInfo.name }}</span>
            </td>
            <td>
              <span>专业名称：</span>
              <span>{{ dataInfo.major_name }}</span>
            </td>
          </tr>
          <tr>
            <td style="padding-top: 2px">
              <span>身份证号：</span>
              <span>{{ dataInfo.idcard }}</span>
            </td>
            <td style="padding-top: 2px">
              <span>证明编号：</span>
              <span>{{ dataInfo.xuehao }}</span>
            </td>
          </tr>
          <tr>
            <td style="padding-top: 2px">
              <span>共计学时：</span>
              <span>{{ dataInfo.studytime }}学时</span>
            </td>
            <td style="padding-top: 2px">
              <span>查询网址：</span>
              <span>https://www.rsx.org.cn</span>
            </td>
          </tr>
        </table>
        <div class="bottom-wrap" v-if="dataInfo.is_muban == 0">
          <div class="left">
            <div class="qr-item">
              <img :src="url" alt="">
              <span>培训学习课程大纲查阅</span>
            </div>
            <div class="qr-item">
              <img :src="url1" alt="">
              <span>在线测评考试试卷查阅</span>
            </div>
          </div>
<!--          <div class="right">-->
<!--            <div class="zhang-wrap">-->
<!--              <img src="../assets/images/zhang.png" alt="">-->
<!--              <span class="tit1">软数星</span>-->
<!--              <span class="tit2">智慧数字化赋能教育考培服务平台</span>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="bottom-wrap" v-if="dataInfo.is_muban == 1">
          <div class="left">
            <div class="qr-item">
              <img :src="url" alt="">
              <span>培训学习课程大纲查阅</span>
            </div>
            <div class="qr-item">
              <img :src="url1" alt="">
              <span>在线测评考试试卷查阅</span>
            </div>
          </div>
<!--          <div class="right">-->
<!--            <div class="zhang-wrap">-->
<!--              <img src="../assets/images/zhang.png" alt="">-->
<!--              <span class="tit1">软 数 星</span>-->
<!--              <span class="tit2">智慧数字化赋能教育考培服务平台</span>-->
<!--            </div>-->
<!--          </div>-->
          <!--        <div class="left1">-->
          <!--          <div class="qr-item">-->
          <!--            <img :src="url" alt="">-->
          <!--            <span>培训学习课程大纲查阅</span>-->
          <!--          </div>-->
          <!--          <div class="qr-item">-->
          <!--            <img :src="url1" alt="">-->
          <!--            <span>在线测评考试试卷查阅</span>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        <div class="right1">-->
          <!--          <div class="zhang-wrap">-->
          <!--            <img src="../assets/images/zhang.png" alt="">-->
          <!--            <span class="tit1">软 数 星</span>-->
          <!--            <span class="tit2">智慧数字化赋能教育考培服务平台</span>-->
          <!--          </div>-->

          <!--          <div class="zhang-wrap">-->
          <!--            <img src="../assets/images/zhang.png" alt="">-->
          <!--            <span class="tit1">支持单位</span>-->
          <!--            <span class="tit2">中国中小企业协会专业技能建设工作委员会</span>-->
          <!--          </div>-->
          <!--        </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import {
  get_zhengshu,
} from "@/api/index";

export default {
  name: "courseList",
  data() {
    return {
      student_id: '',
      major_id: '',
      shijuan_id: '',
      dataInfo: {},
      url: '',
      url1: '',
    }
  },
  mounted() {
    let _this = this
    let info = JSON.parse(_this.$route.query.info)
    _this.student_id = info.student_id
    _this.shijuan_id = info.shijuan_id
    _this.major_id = info.major_id

    _this.getDetails()
    setTimeout(function (){
      _this.url = localStorage.getItem('url')
      _this.url1 = localStorage.getItem('url1')
    },500)
  },
  methods: {
    async downloadCertificate() {
      const element = this.$refs.certificate; // 获取要截图的DOM元素

      if (!element) {
        this.$message.error('证书内容未加载');
        return;
      }

      try {
        // 配置 html2canvas
        const canvas = await html2canvas(element, {
          scale: 2, // 提高清晰度
          useCORS: true, // 支持跨域图片
          logging: false, // 关闭日志
          backgroundColor: '#ffffff', // 背景白色
          width: element.offsetWidth,
          height: element.offsetHeight,
          windowWidth: document.documentElement.offsetWidth,
          windowHeight: document.documentElement.offsetHeight
        });

        // 生成图片 URL
        const imgUrl = canvas.toDataURL('image/png');

        // 创建下载链接
        const link = document.createElement('a');
        link.href = imgUrl;
        link.download = `证书_${this.dataInfo.name}_${this.dataInfo.xuehao}.png`; // 文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (err) {
        console.error('生成图片失败:', err);
        this.$message.error('生成图片失败，请重试');
      }
    },
    getDetails() {
      get_zhengshu({student_id: this.student_id, major_id: this.major_id, shijuan_id: this.shijuan_id}).then(res => {
        if (res.code == 1) {
          this.dataInfo = res.data
        }
      })
    },
    toHome() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
.btn-wrap{
  display: flex;

  .back-wrap{
    position: absolute;
    left: 30px;
    top: 20px;
    //cursor: pointer;
    //border: 1px solid #2257ab;
    //color: #2257ab;
    //padding: 6px 20px;
    //border-radius: 6px;
  }
  .download{
    position: absolute;
    right: 30px;
    top: 20px;
  }
}

.down-wrap{
  //padding: 30px;
  background-color: #fff;
  width: 800px;
  margin: 50px auto 50px auto;
}

.detail-wrap {
  background-image: url("../assets/images/bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  width: 800px;
  height: 1180px;
  position: relative;
  //padding: 30px 0 90px 0;

  .title-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 50px;
    position: relative;
    display: flex;
    align-items: center;
    .right{
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .tit{
        color: #e70014;
        font-size: 10px;
        padding-left: 5px;
        font-weight: bold;
        margin-top: 3px;
      }
      .img2 {
        width: 370px;
        height: 28px;
      }
    }

    .img1 {
      width: 70px;
    }


  }

  .title {
    margin-top: 30px;
    margin-bottom: 75px;
    display: flex;
    justify-content: center;

    img {
      width: 380px;
      height: 62px;
    }
  }

  .line {
    width: 100%;
    height: 10px; /* 调整高度 */
    border-top: none; /* 移除边框 */
    background: linear-gradient(to right, #ddd 50%, transparent 50%) 0 / 90px 6px repeat-x;
    border-radius: 10px;
    margin-bottom: 70px;
  }

  .con-wrap {
    padding: 0 60px;
    font-size: 20px;
    text-indent: 40px;
    line-height: 50px;
  }

  .info-wrap {
    margin: 112px 120px 0 120px;
    width: calc(100% - 240px);
    position: absolute;
    top: 516px;
    th{
      height: 40px;
      font-family: system-ui;
      //font-family: "KaiTi", "楷体", "楷体_GB2312", "STKaiti", "SimSun", "宋体", serif;
      font-weight: bold;
      font-size: 17px;
    }
    td{
      padding: 0 15px;
      height: 40px;
      font-family: emoji;
      //font-family: "KaiTi", "楷体", "楷体_GB2312", "STKaiti", "SimSun", "宋体", serif;
      font-size: 14px;
    }
  }

  .bottom-wrap {
    position: absolute;
    top: 793px;
    left: 50px;
    margin-top: 80px;
    padding: 0 70px;
    display: flex;
    justify-content: space-between;


    .left {
      margin-top: 20px;
      display: flex;

      .qr-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        &:first-child {
          margin-right: 50px;
        }

        img {
          width: 110px;
          height: 110px;
        }

        span {
          color: #333;
          font-size: 10px;
          margin-top: 10px;
        }
      }
    }
    .left1 {
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      .qr-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        &:first-child {
        }

        img {
          width: 110px;
          height: 110px;
        }

        span {
          color: #333;
          font-size: 10px;
          margin-top: 10px;
        }
      }
    }

    .right {
      position: relative;
      display: flex;
      align-items: center;
      //right: -40px;
      //top: 40px;

      .zhang-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          position: absolute;
          width: 170px;
          height: 170px;
          top: 0;
        }

        .tit1 {
          font-size: 12px;
        }

        .tit2 {
          font-size: 12px;
          margin-top: 15px;
        }
      }
    }
    .right1 {
      position: relative;
      display: flex;
      align-items: center;
      align-items: center;
      //right: -40px;
      //top: 40px;

      .zhang-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 30px;

        img {
          position: absolute;
          width: 180px;
          height: 180px;
          top: 72px;
        }

        .tit1 {
          font-size: 13px;
        }

        .tit2 {
          font-size: 13px;
          margin-top: 15px;
        }
      }
    }
  }
}
table, th, td {
  //border: 1px solid #1d2089;
  border: none;
}

</style>
